import React from 'react';
import _ from 'underscore';

import {assertAndContinue} from 'Asserts';
import ModelTypeConstants, {SchemaType} from 'constants/ModelTypeConstants';
import * as SampleConstants from 'constants/SampleConstants';
import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import {TagSchemaSummaryWithFieldsGraphQL} from 'schemas/useTagSchemaSummariesWithFields';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

interface LookupFieldSchemaFieldSelectorProps {
  tagSchema: TagSchemaSummaryWithFieldsGraphQL;
  batchSchema: SampleConstants.BatchSchema | null;
  selectedSchemaField: SchemaFieldConstants.SchemaField | null;
  onChange: (args: {field: SchemaFieldConstants.SchemaField | undefined; schemaType: SchemaType}) => void;
}

class LookupFieldSchemaFieldSelector extends React.Component<LookupFieldSchemaFieldSelectorProps> {
  _handleSchemaFieldSelectionChange = (tagSchemaFieldId: string): void => {
    let field: SchemaFieldConstants.SchemaField = _.findWhere(this.props.tagSchema.fieldsJson, {
      id: tagSchemaFieldId,
    })!;
    let schemaType = ModelTypeConstants.TAG_SCHEMA;
    if (field === undefined && this.props.batchSchema) {
      field = _.findWhere(this.props.batchSchema.fields, {
        id: tagSchemaFieldId,
      })!;
      schemaType = ModelTypeConstants.BATCH_SCHEMA;
    }
    assertAndContinue(field !== undefined, `Tag schema field with id ${tagSchemaFieldId} not found`);
    this.props.onChange({field, schemaType: schemaType as unknown as SchemaType});
  };

  render(): JSX.Element {
    // Collect all of the "value" fields (non-link fields) of the field selected in the lookup field
    // configuration modal tree.
    const childFields = this.props.tagSchema.fieldsJson.filter(
      (field: SchemaFieldConstants.SchemaField) =>
        !SchemaFieldConstants.getRequiredLinkTagSchema(field) &&
        !SchemaFieldConstants.getRequiredLinkBatchSchema(field)
    );
    if (this.props.batchSchema) {
      childFields.push(
        ...this.props.batchSchema.fields.filter(
          (field: SchemaFieldConstants.SchemaField) =>
            !SchemaFieldConstants.getRequiredLinkTagSchema(field) &&
            !SchemaFieldConstants.getRequiredLinkBatchSchema(field)
        )
      );
    }

    return (
      <SelectDropdown
        displayName={this.props.selectedSchemaField?.name ?? 'Select a field'}
        menu={
          <SearchableMenu
            onSelect={(selectedValue) => {
              this._handleSchemaFieldSelectionChange(selectedValue);
            }}
            optionDatas={childFields.map((field: SchemaFieldConstants.SchemaField) => ({
              value: field.id,
              name: field.name,
            }))}
            selectedValue={this.props.selectedSchemaField?.id ?? null}
            width={MenuWidth.FULL}
          />
        }
      />
    );
  }
}

export default LookupFieldSchemaFieldSelector;
